const Labels = require("./Labels");
const LocalStorage = require("./LocalStorage");
const SessionStorage = require("./SessionStorage");
const E164 = require('./E164.js');
var Preconditions = require('./Preconditions.js');
const { v4: uuidv4 } = require('uuid');

function RedChirpState()
{
    this.profile = null;
    this.organization_id = null;
    this.employee_id = null;
    this.muted = false;
    this.suppress_transmit_on_non_assigned_endpoint = false;
    this.labels = new Labels();
    this.eula_check = null;

    this.clearCache();

    this.loadFromStorage();
}


RedChirpState.prototype.clearCache = function()
{
    this.cache = {
        'summaries' : new Map(),
        'conversations' : new Map(),
    };

    this.labels = new Labels();
}

RedChirpState.prototype.provisionBrandedLinkShortener = function()
{
    let ret = this.getDeep(this.profile,'organization_account/provision_branded_link_shortener');
    return ret == true;
}

RedChirpState.prototype.provisionOutboundCalling = function()
{
    let ret = this.getDeep(this.profile,'organization_account/provision_outbound_calling');
    return ret == true;
}

RedChirpState.prototype.getPrimaryTimezone = function()
{
    let def = 'America/Phoenix';
    if ( this.profile == null ) return def;
    if ( this.profile.organization_account == null ) return def;
    if ( this.profile.organization_account.primary_timezone == null ) return def;

    return this.profile.organization_account.primary_timezone;
}

RedChirpState.prototype.getOrganizationSpecialPurpose = function()
{
    return this.getDeep(this.profile,'organization_account/special_purpose');
}

RedChirpState.prototype.getPaymentVanityURLPortion = function()
{
    return this.getDeep(this.profile, 'organization_account/payment_settings/vanity_url_portion');
}

RedChirpState.prototype.getDeep = function(start, path)
{
    if ( start == null ) return null;

    let arr = path.split('/');

    for ( let i = 0; i < arr.length; i++ )
    {
        start = start[arr[i]];

        if ( start == null )
            return null;
    }

    return start;
}

RedChirpState.prototype.canTransmitOn = function(active_endpoint)
{
    // Can the current user transmit on the specified active endpoint (i.e. do they own it?)
    if ( this.profile == null || this.profile.employee_account == null ) return false;
    if ( this.profile.employee_account.is_system_admin ) return true;
    if ( this.profile.employee_account.is_organization_admin ) return true;

    let employee_endpoint = this.getEmployeeEndpoint(active_endpoint, null);

    if ( employee_endpoint == null ) return false;

    if ( employee_endpoint.assigned_to_employee_id == this.employee_id ) return true;
    return false;
}

RedChirpState.prototype.getEmployeeId = function()
{
    return this.getDeep(this.profile, 'employee_account/employee_id');
}

RedChirpState.prototype.getAuthEmployeeId = function()
{
    return this.getDeep(this.profile, 'auth_employee_account/employee_id');
}


RedChirpState.prototype.endpointOwnedByCurrentEmployee = function(active_endpoint)
{
    if ( active_endpoint == null ) return false;
    let employee_endpoint = this.getEmployeeEndpoint(active_endpoint, null);
    if ( employee_endpoint == null ) return false;

    return employee_endpoint.assigned_to_employee_id == this.employee_id;
}

RedChirpState.prototype.updateProfile = function(new_profile)
{
    // Store permenantly...
    new LocalStorage().set('profile',new_profile);
    new LocalStorage().set('profile_last_updated', Date.now());

    // Store sesion
    new SessionStorage().set('profile',new_profile);
    new SessionStorage().set('profile_last_updated', Date.now());

    this.loadFromStorage();

    // If we are signed out, make sure that cache is emptied
    if ( !this.isSignedIn() )
        this.clearCache();
}

RedChirpState.prototype.updateInstalledApps = function(new_installed_apps)
{
    this.profile.installed_apps = new_installed_apps;
    this.updateProfile(this.profile);
}

RedChirpState.prototype.getProfileLastUpdated = function()
{
    let ret = parseInt(new LocalStorage().get('profile_last_updated'));

    if ( isNaN(ret) )
        return 0;

    return ret;
}

RedChirpState.prototype.isSignedIn = function()
{
    return this.profile != null;
}

RedChirpState.prototype.checkSignedIn = function()
{
    if (!this.isSignedIn())
        throw new Error("You must be signed in");
}

RedChirpState.prototype.hideSignInAsFooter = function()
{
    sessionStorage.setItem('hide_sign_in_as_footer', 'true');
}

RedChirpState.prototype.clearHideSignInAsFooter = function()
{
    sessionStorage.setItem('hide_sign_in_as_footer', 'false');
}

RedChirpState.prototype.hasExplicitHideSignInAsFooter = function()
{
    return sessionStorage.getItem('hide_sign_in_as_footer') == 'true';
}


RedChirpState.prototype.showSignedInAsFooter = function()
{
    if ( sessionStorage.getItem('hide_sign_in_as_footer') == 'true' )
        return false;

    if ( this.getAuthActorCanAccessMultipleEmployeeAccounts() )
        return true;

    return false;
}

RedChirpState.prototype.signedInFooterText = function()
{
    return this.profile.employee_label+" ( "+this.profile.organization_account.label+" )";
}

RedChirpState.prototype.loadFromStorage = function()
{
    try
    {
        this.muted = new LocalStorage().get('muted','false') == 'true';

        // First try and load the profile from the session...
        this.profile = new SessionStorage().get('profile',null);

        // If you can't, then try local storage...
        if ( this.profile == null )
        {
            this.profile = new LocalStorage().get('profile',null);

            if ( this.profile != null )
            {
                new SessionStorage().set('profile', this.profile); // set the session profile (populate from local storage basically)
            }
        }

        if ( !Preconditions.hasFields(this.profile, "auth_token: String", "organization_account: Object", "employee_account: Object") )
        {
            // profile is either not present in storage or is not valid
            this.loadEmptyProfile();
            return;
        }

        this.organization_id = this.profile.organization_account.organization_id;
        this.employee_id = this.profile.employee_account.employee_id;

        if ( !this.hasAlertSound() )
            this.muted = true;
    }
    catch(e)
    {
        this.setEmptyProfile();
        return;
    }
}

RedChirpState.prototype.hasAlertSound = function()
{
    return this.profile.extended_data.alert_sound_url != null;
}

RedChirpState.prototype.getAuthToken = function()
{
    if ( !this.isSignedIn() )
        return null;

    return this.profile.auth_token;
}

RedChirpState.prototype.getAuthActAs = function()
{
    if ( !this.isSignedIn() )
        return null;

    let ret = this.profile.employee_account.employee_id;
    //console.log('ACT AS = '+ret+', '+this.profile.employee_account.username);
    return ret;
}

RedChirpState.prototype.getDeviceId = function()
{
    let ret = window.localStorage.getItem('red-chirp-device-id');
    if ( ret != null ) return ret;

    ret = uuidv4();
    window.localStorage.setItem('red-chirp-device-id', ret);

    return window.localStorage.getItem('red-chirp-device-id');
}


RedChirpState.prototype.loadEmptyProfile = function()
{
    this.profile = null;
    this.organization_id = null;
    this.employee_id = null;
    this.muted = false;
}

RedChirpState.prototype.getEmployeeAccount = function()
{
    this.checkSignedIn();
    return this.profile.employee_account;
}

RedChirpState.prototype.getOrganizationAccount = function()
{
    this.checkSignedIn();
    return this.profile.organization_account;
}

// Effective SSO values used for logout redirect
RedChirpState.prototype.getEffectiveAuth0Domain = function()
{
    // Prefer organization SSO settings effective domain if present on profile
    // profile may not contain this; callers should handle null
    return this.getDeep(this.profile, 'organization_sso_settings_effective/auth0_domain');
}

RedChirpState.prototype.getEffectiveAuth0ClientId = function()
{
    return this.getDeep(this.profile, 'organization_sso_settings_effective/auth0_client_id');
}

RedChirpState.prototype.getOrganizationId = function()
{
    this.checkSignedIn();
    return this.getOrganizationAccount().organization_id;
}

RedChirpState.prototype.getOrganizationLabel = function()
{
    this.checkSignedIn();
    return this.getOrganizationAccount().label;
}

RedChirpState.prototype.getEmployeeEndpoints = function()
{
    this.checkSignedIn();

    let ret = this.profile.employee_endpoints;

    if ( Preconditions.isNull(ret) )
        return [];

    return ret;
}

RedChirpState.prototype.getEmployeeEndpoint = function(endpoint, default_value)
{
    this.checkSignedIn();

    let endpoints = this.getEmployeeEndpoints();

    for ( let i = 0; i < endpoints.length; i++ )
    {
        if ( endpoints[i].endpoint.endsWith(endpoint) )
            return endpoints[i];
    }

    return default_value;
}

RedChirpState.prototype.isDemoOrganization = function()
{
    this.checkSignedIn();
    return this.getOrganizationAccount().is_demo_organization;
}

RedChirpState.prototype.isTestOrganization = function()
{
    this.checkSignedIn();
    return this.getOrganizationAccount().is_test_organization;
}

RedChirpState.prototype.isDemoOrTestOrganization = function()
{
    return this.isDemoOrganization() || this.isTestOrganization();
}

RedChirpState.prototype.hasMultipleEmployeeEndpoints = function()
{
    return this.getEmployeeEndpoints().length > 1;
}

RedChirpState.prototype.hasNoEmployeeEndpoints = function()
{
    return this.getEmployeeEndpoints().length === 0;
}

RedChirpState.prototype.isSystemsAdmin = function()
{
    if ( !this.isSignedIn() ) return false;
    return this.getEmployeeAccount().is_system_admin;
}

RedChirpState.prototype.isOrganizationAdmin = function()
{
    if ( !this.isSignedIn() ) return false;
    return this.getEmployeeAccount().is_organization_admin;
}

RedChirpState.prototype.findConversationSummary = function(conversation_id, default_value)
{
    if ( !Preconditions.isString(conversation_id) )
        return default_value;

    for (const [key, value] of this.cache.summaries.entries())
    {
        let summary = value.findByConversationId(conversation_id);
        if ( !Preconditions.isNull(summary) )
            return summary;
    }

    return default_value;
}

RedChirpState.prototype.setMuted = function(value)
{
    Preconditions.checkBoolean(value);
    this.muted = value;
    new LocalStorage().set('muted',value ? 'true' : 'false');
}

RedChirpState.prototype.getEmployeeLabel = function()
{
    this.checkSignedIn();

    let label = this.profile.employee_contact.name.explicit_label;

    if ( label != null )
        return label;

    let first = this.profile.employee_contact.name.first;
    let last = this.profile.employee_contact.name.last;

    if ( first == null ) first = '';
    if ( last == null ) last = '';

    return (first + ' ' + last).trim();
}

RedChirpState.prototype.upsertConversationSummaries = function(summaries)
{
    this.cache.summaries.set(summaries.getForEndpoint(),summaries);
}

RedChirpState.prototype.upsertLabels = function(new_labels_array)
{
    this.labels.upsert(new_labels_array);
}

RedChirpState.prototype.upsertConversation = function(conversation)
{
    this.cache.conversations.set(conversation.getConversationId(),conversation);
}

RedChirpState.prototype.getCurrentAdfIntegrations = function()
{
    if ( this.profile == null ) return [];
    if ( this.profile.integration_settings == null ) return [];
    if ( this.profile.integration_settings.adf_integrations == null ) return [];

    return this.profile.integration_settings.adf_integrations;
}

RedChirpState.prototype.getCurrentAdfIntegrations = function()
{
    if ( this.profile == null ) return [];
    if ( this.profile.integration_settings == null ) return [];
    if ( this.profile.integration_settings.adf_integrations == null ) return [];

    return this.profile.integration_settings.adf_integrations;
}

RedChirpState.prototype.isCRMEnabled = function(content_type)
{
    let profile = this.profile;

    if ( profile == null ) return false;
    if ( profile.integration_crm_summaries == null ) return false;

    for ( let i = 0; i < profile.integration_crm_summaries.length; i++ )
    {
        let summary = profile.integration_crm_summaries[i];

        if ( summary.content_type == content_type && summary.enabled == true )
            return true;
    }

    return false;
}

RedChirpState.prototype.isCommerce7Enabled = function()
{
    return this.isCRMEnabled('commerce7');
},

RedChirpState.prototype.isClearCareEnabled = function()
{
    return this.isCRMEnabled('clear-care');
},

RedChirpState.prototype.isVinSuiteEnabled = function()
{
    return this.isCRMEnabled('vinsuite');
},

RedChirpState.prototype.isWineDirectEnabled = function()
{
    return this.isCRMEnabled('winedirect');
},

RedChirpState.prototype.isECellarEnabled = function()
{
    return this.isCRMEnabled('ecellar');
},

RedChirpState.prototype.isBottle360Enabled = function()
{
    return this.isCRMEnabled('bottle360');
},

RedChirpState.prototype.isFINRAEnabled = function()
{
    let profile = this.profile;

    if ( profile == null ) return false;
    if ( profile.organization_account == null ) return false;
    if ( profile.organization_account.features.compliance_finra == null ) return false;


    return profile.organization_account.features.compliance_finra;
},

RedChirpState.prototype.showMessageTypeIndicator = function()
{
    let profile = this.profile;

    if ( profile == null ) return false;
    if ( profile.organization_account == null ) return false;
    if ( profile.organization_account.features.show_message_type_indicator == null ) return false;


    return profile.organization_account.features.show_message_type_indicator;
},

RedChirpState.prototype.isSystemAdmin = function()
{
    if ( this.profile == null ) return false;
    if ( this.profile.employee_account == null ) return false;
    return this.profile.employee_account.is_system_admin == true;
}

RedChirpState.prototype.showAlphaFeatures = function()
{
    let organization_id = this.profile.organization_account.organization_id;

    // The "test" organization (Test Chirp, RedRock Realty, Red Country Jeep Tours, Red Stallion Buggy Whips)
    if ( organization_id == 'd0a00313-4d12-4d05-9fad-5203575674e6' ) return true;
    if ( organization_id == '8a732595-6621-4d6d-af37-0819110ae721' ) return true;
    if ( organization_id == '0f0b45f1-9dfb-468d-bcd4-fcb49ef01154' ) return true;
    if ( organization_id == '4910a846-3c25-11eb-adc1-0242ac120002' ) return true;

    return false;
}

RedChirpState.prototype.supportsBetaFeatures = function()
{
    return this.getOrganizationAccount()?.features?.opt_in_beta_features || false;
}

RedChirpState.prototype.showBulkMessages = function()
{
    if ( this.profile == null ) return false;
    if ( this.profile.employee_account == null ) return false;
    if ( this.profile.employee_account.bulk_message_permissions == 'no-access' ) return false;

    return true;
}

RedChirpState.prototype.isAuthActorSystemAdmin = function()
{
    return this.getDeep(this.profile,'auth_employee_account/is_system_admin') == true;
}

RedChirpState.prototype.isActingAsSomoneElse = function()
{
    let auth_employee_id = this.getDeep(this.profile,'auth_employee_account/employee_id');

    if ( auth_employee_id == null )
        return false;

    return auth_employee_id != this.getDeep(this.profile,'employee_account/employee_id');
}

RedChirpState.prototype.offerSignOutReturnToAdminAccount = function()
{
    if ( !this.isAuthActorSystemAdmin() )
        return false;

    if ( !this.isActingAsSomoneElse() )
        return false;

    return true;
}

RedChirpState.prototype.getAuthActor = function()
{
    return this.getDeep(this.profile,'auth_employee_account');
}

RedChirpState.prototype.getAuthActorUsername = function()
{
    return this.getDeep(this.profile,'auth_employee_account/username');
}

RedChirpState.prototype.getActorUsername = function()
{
    return this.getDeep(this.profile,'employee_account/username');
}

RedChirpState.prototype.getAuthActorEmployeeId = function()
{
    return this.getDeep(this.profile,'auth_employee_account/employee_id');
}

RedChirpState.prototype.getAuthActorCanAccessMultipleEmployeeAccounts = function()
{
    return this.getDeep(this.profile,'auth_employee_account/can_access_multiple_employee_accounts');
}

RedChirpState.prototype.resetDismissedWarnings = function()
{
    let keys = Object.keys(window.localStorage);

    for ( let i = 0; i < keys.length; i++ )
    {
        let key = ''+keys[i];
        if ( key.startsWith('dismiss_warning_') )
        {
            window.localStorage.setItem(key,'false');
        }
    }
}

RedChirpState.prototype.isWarningDismissed = function(warning_code)
{
    let key = 'dismiss_warning_'+warning_code.toLowerCase();
    let value = window.localStorage.getItem(key);

    return value == true || value == 'true';
}

RedChirpState.prototype.resetWarningDismissed = function(warning_code)
{
    let key = 'dismiss_warning_'+warning_code.toLowerCase();
    window.localStorage.setItem(key,'false');
}

RedChirpState.prototype.dismissWarning = function(warning_code)
{
    let key = 'dismiss_warning_'+warning_code.toLowerCase();
    window.localStorage.setItem(key,'true');
}


RedChirpState.prototype.hasRedChirpStaffRole = function(role)
{
    if ( Array.isArray(role) )
    {
        return role.some((item) => this.hasRedChirpStaffRole(item));
    }

    return (this.getDeep(this.profile,'employee_account/red_chirp_staff_roles') ?? '[]').includes(role);
}

RedChirpState.prototype.hasRedChirpStaffRoleAdministrator = function()
{
    return this.hasRedChirpStaffRole('administrator')
}

RedChirpState.prototype.hasRedChirpStaffRoleFinance = function()
{
    return this.hasRedChirpStaffRole('finance')
}

RedChirpState.prototype.authAccountHasRedChirpStaffRole = function(role)
{
    if ( Array.isArray(role) )
    {
        return role.some((item) => this.hasRedChirpStaffRole(item));
    }

    return (this.getDeep(this.profile,'auth_employee_account/red_chirp_staff_roles') ?? '[]').includes(role);
}

RedChirpState.prototype.isAccountArchived = function()
{
    return this.getDeep(this.profile,'employee_account/is_archived') === true;
}

RedChirpState.prototype.isOrganizationArchived = function()
{
    return this.getDeep(this.profile,'organization_account/archived_info') !== null &&
           this.getDeep(this.profile,'organization_account/archived_info') !== undefined;
}

module.exports = RedChirpState;